// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notes_resouce_portal_wrapper .content_resouce_modal {\n  max-height: 90vh;\n}", ""]);
// Exports
module.exports = exports;
